<p-fieldset>
    <p-header class="article-title">
        <span class="article-title">{{'TITLE-INTER-CONFIG' | translate}}</span>
    </p-header>

    <p-tabView>
        <p-tabPanel header="Integrações">
            <p-card class="card-bg">
                <div class="row row-div">
<!--                    <div class="form-control mr-4">-->
<!--                        <div clas="mb-1"><label for="Login">Login de acesso</label></div>-->
<!--                        <input pInputText [(ngModel)]="interIntegrationConfig.clientId" name="Login"-->
<!--                               type="text"-->
<!--                        >-->
<!--                    </div>-->
                    <div class="form-control mr-4">
                        <div clas="mb-1"><label for="clientId">Client Id</label></div>
                        <input pInputText [(ngModel)]="interIntegrationConfig.clientId" name="clientId"
                               type="text"
                        >
                    </div>
                    <div class="form-control mr-4">
                        <div clas="mb-1"><label for="clientSecret">Client Secret</label></div>
                        <input pInputText [(ngModel)]="interIntegrationConfig.clientSecret" name="clientSecret"
                               type="password"
                        >
                    </div>
                    <div class="form-control mr-4">
                        <div clas="mb-1"><label for="clientSecret">Numero Conta Inter</label></div>
                        <input pInputText [(ngModel)]="interIntegrationConfig.accountNumber" name="clientSecret"
                               type="text"
                        >
                    </div>
                    <div class="form-control mr-4">
                        <div clas="mb-1"><label for="clientSecret">Numero DV Conta Inter</label></div>
                        <input pInputText [(ngModel)]="interIntegrationConfig.accountNumberVd" name="clientSecret"
                               type="text"
                        >
                    </div>
                    <div class="form-control mr-4">
                        <label class="mr-2 mb-1">Conta para Crédito</label>
                        <p-dropdown [(ngModel)]="interIntegrationConfig.account"  appendTo="body"
                                    [options]="accountDropdown">
                        </p-dropdown>
                    </div>
                    <div class="form-control mr-4">
                        <div clas="mb-1">
                            <i class="{{getCheckIcon(true)}}" style="font-size: 1.2rem"></i>
                            <label for="crt">Certificado</label>
                            <p-fileUpload
                                    name="attachment"
                                    mode="basic"
                                    [maxFileSize]=100000000
                                    chooseLabel=" "
                                    accept=".crt"
                                    #uploadCrt
                                    [auto]=true
                                    [customUpload]=true
                                    chooseIcon="pi pi-id-card"
                                    class="uploadIcon"
                                    (uploadHandler)="setFileCrt($event.files)"
                            >
                            </p-fileUpload>
                        </div>
                    </div>
                    <div class="form-control mr-4">
                        <div clas="mb-1">
                            <i class="{{getCheckIcon()}}" style="font-size: 1.2rem"></i>
                            <label for="crt">Key</label>
                            <p-fileUpload
                                    name="attachment"
                                    mode="basic"
                                    [maxFileSize]=100000000
                                    chooseLabel=" "
                                    accept=".key"
                                    #uploadKey
                                    [auto]=true
                                    [customUpload]=true
                                    chooseIcon="pi pi-key"
                                    class="uploadIcon"
                                    (uploadHandler)="setFileKey($event.files)"
                            >
                            </p-fileUpload>
                        </div>
                    </div>
                    <div class="form-control mr-4">
                        <div clas="mb-1">
                            <i class="{{getWebhookIcon()}}}" style="font-size: 1.2rem"></i>
                            <label>Webhook</label>
                        </div>
                    </div>
                </div>
                <div class="text-right mt-5 mr-5">
                    <button class="easymarine primary" (click)="save()">Salvar</button>
                </div>
            </p-card>
        </p-tabPanel>
    </p-tabView>
</p-fieldset>
